<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: $t('fines.breadcrumb') }]" />


      <a-table
        :dataSource="fines"
        :pagination="false"
        rowKey="id"
        class="theme-aware-box"
      >
        <a-table-column :title="$t('fines.number')" key="id" data-index="id" />
        <a-table-column :title="$t('fines.type')" key="title" data-index="title" />
        <a-table-column :title="$t('fines.amount')" key="amount" data-index="amount" />
      </a-table>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  computed: {
    fines() {
      return this.$store.getters.fines
    }
  }
}
</script>